<template>
  <span @click="toggle">
    <slot />
  </span>
</template>

<script setup>
import { createPopup } from '@typeform/embed'
import '@typeform/embed/build/css/widget.css'
import '@typeform/embed/build/css/popup.css'

const props = defineProps({
  companyAccountId: {
    required: true,
  },
  userAccountId: {
    required: true,
  },
  hireId: {
    required: true,
  },
  freelancerId: {
    required: false,
  },
  companyName: {
    type: String,
    required: true,
  },
  jobCreatedByUserId: {
    required: true,
  },
})

const { toggle } = createPopup('xs29lSUP', {
  size: 80,
  hidden: {
    company_account_id: props.companyAccountId,
    user_account_id: props.userAccountId,
    hire_id: props.hireId,
    ...(props.freelancerId && { freelancer_id: props.freelancerId }),
    company_name: props.companyName,
    job_created_by_user_id: props.jobCreatedByUserId,
  },
})
</script>
